import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule, MatDialogModule } from '@angular/material';

import { PagesRoutingModule } from './pages-routing.module';
import { FeedbackModule } from '../feedback/feedback.module';
import { PrivacyComponent } from './privacy/privacy.component'
@NgModule({
  imports: [
    CommonModule,
    PagesRoutingModule,
    MatProgressSpinnerModule,
    FeedbackModule,
    MatDialogModule,

  ],
  
})
export class PagesModule { }
